import { Button, CircularProgress, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core';
import { Select, SelectArrowDownIcon, TextInput } from '@room-match/shared-ui-components';
import React, { useMemo, useState } from 'react';
import { useVerificationForm } from './useVerificationForm';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Autocomplete } from '@material-ui/lab';
import { useDebounce } from 'use-debounce';
import { agencyService } from 'shared/services/agencyService';
import { COLORS } from 'shared/constants/COLORS';
import { ls } from 'shared/utils/ls';
import { IAgency } from 'shared/interfaces/utils/IAgency';
import { auditionService } from 'shared/services/auditionService';
import { IVerifyAuditionResponse } from 'shared/interfaces/IAudition';
import Result from './Result';
import { useHistory } from 'react-router-dom';

const { getAgencies } = agencyService();
const { verifyAudition } = auditionService();

const Verification = () => {
  const { mutate, isLoading } = verifyAudition();
  const { getLS, setLS } = ls();
  const roles = getLS('project_roles');
  const [query, setQuery] = useState<string>('');
  const [queryValue] = useDebounce(query, 500);
  const [representative, setRepresentative] = useState();
  const [auditionData, setauditionData] = useState<IVerifyAuditionResponse | null>();
  const history = useHistory();
  const { data: agencies, isLoading: isAgencyLoading } = getAgencies(
    {
      search: queryValue,
    },
    true,
  );

  const [isRepresented, setisRepresented] = useState(false);
  const { form } = useVerificationForm({
    onSubmit: (values) => {
      const newValues = { ...values };
      //remove agency_id from values if it is not represented
      if (!isRepresented && newValues.agency_id) {
        delete newValues.agency_id;
      }
      mutate(newValues, {
        onSuccess: (data) => {
          setLS('role_id', form.values.casting_role_id);
          setauditionData(data);
        },
        onError: (err) => {
          console.log('error', err);
        },
      });
    },
  });

  const getData: any = useMemo(() => {
    if (isAgencyLoading) {
      return;
    } else {
      return agencies ? (agencies?.pages[0].data as any).agencies : undefined;
    }
  }, [agencies, isAgencyLoading]);

  return auditionData?.data.length ? (
    <Result data={auditionData?.data} talentName={form.values.first_name} onCancel={() => setauditionData(null)} />
  ) : auditionData?.data.length === 0 ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        gap: 20,
      }}
    >
      <CustomTypography fontSize={18} style={{ textAlign: 'center' }}>
        There is no match found in the schedule please discuss with the session director or casting director at the
        audition.
      </CustomTypography>
      <CustomTypography fontSize={16} style={{ textAlign: 'center' }}>
        If you weren't scheduled and are new, please click the button below to create a profile and checkin
      </CustomTypography>
      <div
        style={{
          display: 'flex',
          gap: 20,
        }}
      >
        <Button
          fullWidth
          onClick={() => setauditionData(null)}
          style={{
            height: 50,
          }}
          variant="outlined"
          color="primary"
        >
          <CustomTypography fontSize={16} fontWeight={700} color="white">
            Cancel
          </CustomTypography>
        </Button>
        <Button
          fullWidth
          disabled={Object.keys(form.errors).length > 0 || isLoading}
          onClick={() => history.push('/signup')}
          style={{
            background: COLORS.PRIMARY,
            height: 50,
          }}
        >
          <CustomTypography fontSize={16} fontWeight={700} color="white">
            Create Account
          </CustomTypography>
        </Button>
      </div>
    </div>
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
      }}
    >
      <TextInput
        placeholder="First Name"
        name="first_name"
        onChange={form.handleChange}
        fullWidth
        errorMessage={form.touched.first_name ? form.errors.first_name : ''}
        value={form.values.first_name}
      />
      <TextInput
        placeholder="Last Name"
        name="last_name"
        onChange={form.handleChange}
        fullWidth
        errorMessage={form.touched.last_name ? form.errors.last_name : ''}
        value={form.values.last_name}
      />
      {/* MUI radio button for form */}
      <RadioGroup row aria-label="position" name="position" defaultValue="top" style={{ marginTop: 8 }}>
        <FormControlLabel
          value="end"
          control={<Radio color="primary" />}
          label="Non-Represented"
          labelPlacement="end"
          checked={!isRepresented}
          onChange={() => setisRepresented(false)}
        />
        <FormControlLabel
          value="end"
          control={<Radio color="primary" />}
          label="Represented"
          labelPlacement="end"
          checked={isRepresented}
          onChange={() => setisRepresented(true)}
        />
      </RadioGroup>
      {isRepresented ? (
        <React.Fragment>
          <Autocomplete
            loading={isAgencyLoading}
            id="multiple-tags"
            options={getData || []}
            getOptionLabel={(option: any) => {
              const { full_name, name } = option;
              //create a logic that will check current inputValue if it contains agency name then retunr the agency name else return the full name
              if (queryValue.length > 0) {
                if (full_name && full_name.toLowerCase().includes(queryValue.toLowerCase())) {
                  return full_name.toLowerCase();
                } else {
                  return name;
                }
              }

              return '';
            }}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            renderTags={() => null}
            onChange={(e, newValue: any) => {
              setRepresentative(newValue);
              form.setFieldValue('agency_id', newValue.id);
            }}
            value={representative}
            renderOption={(option: any) => {
              const { name, logo, full_name, type } = option;

              return (
                <Grid
                  container
                  spacing={2}
                  style={{ margin: 5, display: 'flex', alignItems: 'center', gap: '.5em', flexWrap: 'nowrap' }}
                >
                  <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                      style={{ borderRadius: 10 }}
                      loading="lazy"
                      width="37"
                      src={logo || `https://ui-avatars.com/api/?background=random&name=${full_name || name}&length=1`}
                      alt=""
                    />
                  </Grid>
                  <Grid item xs={11}>
                    <Grid item xs={12} style={{ fontSize: 16, fontWeight: 500 }}>
                      {full_name || name}
                    </Grid>
                    <Grid item xs={12} style={{ color: '#93a1b6', fontSize: 14 }}>
                      <div style={{ display: 'flex' }}>
                        <CustomTypography
                          fontSize={12}
                          fontWeight={700}
                          style={{ fontStyle: 'italic' }}
                          color="mainGray"
                        >
                          {name ? `${name} -\xa0` : ''}
                        </CustomTypography>
                        <CustomTypography fontSize={12} style={{ fontStyle: 'italic' }} color="mainGray">
                          {type ? type : ' '}
                        </CustomTypography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={'Type Agency Name'}
                variant="outlined"
                margin="normal"
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            )}
          />

          <CustomTypography>
            <span style={{ color: COLORS.PRIMARY }}>Note: </span>
            If your agency is not listed here please contact your agency
          </CustomTypography>
        </React.Fragment>
      ) : (
        <React.Fragment />
      )}
      <Select
        variant="outlined"
        fullWidth
        data={JSON.parse(roles)}
        onChange={form.handleChange}
        IconComponent={SelectArrowDownIcon}
        name="casting_role_id"
        value={form.values.casting_role_id}
        errorMessage={form.touched.casting_role_id ? form.errors.casting_role_id : ''}
      />
      <Button
        disabled={Object.keys(form.errors).length > 0 || isLoading}
        onClick={() => form.handleSubmit()}
        style={{
          background: COLORS.PRIMARY,
          marginTop: 30,
          height: 50,
          width: 'fit-content',
          alignSelf: 'center',
          padding: '0 50px',
          minWidth: 300,
          opacity: Object.keys(form.errors).length > 0 || isLoading ? 0.5 : 1,
          transition: 'opacity 0.3s',
        }}
      >
        {isLoading ? (
          <CircularProgress style={{ color: 'white' }} size={25} />
        ) : (
          <CustomTypography fontSize={16} fontWeight={700} color="white">
            Find my Audition
          </CustomTypography>
        )}
      </Button>
    </div>
  );
};

export default Verification;
